var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F8F8F8",
    fillOpacity: 0.05,
    style: {
      mixBlendMode: "luminosity"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "url(#paint0_linear_2388_19480)",
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9557 6.79201C15.8369 6.60067 15.627 6.48429 15.4018 6.49039C13.5214 6.54136 11.6465 6.86026 9.83586 7.44728C9.7044 7.4899 9.60896 7.60405 9.59029 7.74099L9.30371 11.513C9.27173 11.934 9.64598 12.2717 10.0615 12.1969L18.2655 10.7191C18.2987 10.7036 18.3331 10.6903 18.3685 10.6792L15.9557 6.79201ZM18.3685 13.0095C18.3208 12.9946 18.275 12.9756 18.2314 12.9528L10.9454 24.5414C10.8271 24.7295 10.93 24.978 11.1475 25.0233C12.4967 25.3044 13.8649 25.4654 15.2358 25.5064C15.5431 25.5156 15.8095 25.2996 15.8722 24.9986L18.3685 13.0095ZM17.1096 25.4877C16.6968 25.5083 16.384 25.1295 16.4682 24.7249L18.9081 13.0017C18.9448 12.9878 18.9803 12.9715 19.0143 12.9528L21.3046 24.5775C21.3382 24.7476 21.2313 24.914 21.0621 24.9517C19.7587 25.2428 18.4363 25.4215 17.1096 25.4877ZM19.1413 10.6792L17.0008 7.51619C16.7078 7.08322 17.0245 6.506 17.5456 6.54841C19.0672 6.67225 20.5779 6.97226 22.0463 7.44834C22.1761 7.4904 22.271 7.60216 22.2914 7.73698L22.5884 11.2427C22.6305 11.7393 22.1178 12.094 21.668 11.8797L19.2038 10.7057C19.1834 10.6961 19.1626 10.6872 19.1413 10.6792ZM22.7978 13.1822C22.7854 13.0847 22.7288 12.9984 22.6446 12.9477L20.1218 11.43C20.1346 11.4553 20.146 11.4812 20.1562 11.5079L21.9233 16.2162C22.1678 16.8677 23.0498 16.7206 23.0258 16.0251C22.9931 15.0753 22.9171 14.1267 22.7978 13.1822ZM17.3173 11.4537C17.3037 11.4804 17.2914 11.5079 17.2806 11.5361L10.0445 17.9956C9.64268 18.3543 9.00552 18.0917 8.9844 17.5534C8.92767 16.1082 8.94322 14.7104 9.12097 13.2408C9.13767 13.1027 9.24252 12.9919 9.3792 12.9658L17.3173 11.4537ZM17.6037 12.2381L9.20685 19.3688C9.0488 19.503 8.96407 19.7051 8.98529 19.9114C9.03399 20.3848 9.10356 20.8574 9.16782 21.3289L9.58242 24.3714C9.60568 24.5421 9.72919 24.6821 9.89563 24.7264C9.95926 24.7434 10.023 24.76 10.0867 24.7764L17.6416 12.3379C17.6269 12.3057 17.6142 12.2724 17.6037 12.2381ZM22.9334 19.7373C22.942 19.6356 22.9257 19.5334 22.8866 19.4391L19.9019 12.2381C19.893 12.267 19.8826 12.2952 19.8708 12.3227L21.9796 24.7274L21.9873 24.7253C22.1516 24.6816 22.2746 24.5445 22.3 24.3763L22.6919 21.7875C22.795 21.1063 22.8755 20.4225 22.9334 19.7373Z",
    fill: "url(#paint1_linear_2388_19480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2388_19480",
    x1: 16,
    y1: -3.63129e-7,
    x2: 29.9206,
    y2: 35.1399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2388_19480",
    x1: 15.9998,
    y1: 6.48389,
    x2: 15.9998,
    y2: 25.5162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapse);
export default __webpack_public_path__ + "static/media/logo_collapse.9ccb94c9bfa084edfb40a94cd6ea75c3.svg";
export { ForwardRef as ReactComponent };